import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DragDropRegion, DragDropService } from '@shared/services/drag-drop.service';
import { MobileService } from '@shared/services/mobile.service';
import { ScopeService } from '@shared/services/scope.service';
import { SidebarMenu, SidebarMenuItem } from './sidebar-menu.type';

@Component({
  selector: 'rav-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss']
})
export class SidebarMenuComponent {
  @Input() menus: SidebarMenu[];
  @Input() isSidebarCollapsed: boolean;

  DragDropRegion = DragDropRegion;

  constructor(
    public mobile: MobileService,
    public router: Router,
    public scope: ScopeService,
    public dragDrop: DragDropService
  ) {}

  dragEnter(item: SidebarMenuItem) {
    if (!item.dragDroppable) return;
    this.dragDrop.target = {
      region: DragDropRegion.OtherSidebarMenu,
      value: item.name as 'Inbox' | 'Archive' | 'Trash'
    };
  }

  /**
   * Determines if the folders menu is active or not
   */
  isFoldersActive(itemName: string): boolean {
    return this.router.url.split('?')[0] === '/folders' && itemName === 'Folders';
  }
}
